import React from 'react';
import {Outlet} from 'react-router-dom';
import {AdminLayout} from '../../../layout/admin';
import {DictionaryType} from '../types/DictionaryItem';

const PlaceSections: React.FC = () => {
  return (
    <AdminLayout>
      <Outlet context={{
        dictionaryType: DictionaryType.PLACE_SECTION,
        indexPath: '/place-sections'
      }}/>
    </AdminLayout>
  );
};

export default PlaceSections;
